import { z } from 'zod';

export const jobVenueFeedbackSchema = z.object({
  job_venue_id: z.number().optional(),
  job_date_id: z.number().optional(),
  feedback: z.string().min(1, { message: "Please provide feedback about the venue" }),
  author_id: z.number().optional(),
});

export type JobVenueFeedbackFormValues = z.infer<typeof jobVenueFeedbackSchema>;

export const defaultJobVenueFeedbackValues: Partial<JobVenueFeedbackFormValues> = {
  feedback: '',
};

export const mapVenueFeedbackForBackend = (
  data: Partial<JobVenueFeedbackFormValues> & { job_venue_id: number; job_date_id: number },
  authorId: number
): JobVenueFeedbackFormValues => {
  return {
    job_venue_id: data.job_venue_id,
    job_date_id: data.job_date_id,
    feedback: data.feedback || '',
    author_id: authorId,
  };
};
